<template>
<div class="left-content">
  <div class="type">
    <div class="type-left">{{$t('global.分类')}}
      <span>|</span>
    </div>
    <div
      class="type-right pointer"
      v-for="(item,index) in typeContent"
      :key="index"
      :class="{ selected: typeIndex === index }"
      @click="selectType(index)"
      >
      {{item}}
    </div>
  </div>
  <div class="allproduct">
    <div class="videoCreation" v-for="(item, index) in videoList" :key="index">
      <video-creation :info="item"></video-creation>
    </div>
  </div>
  <pages
    :page-size="pagerParams.pageSize"
    :page-count="pagerParams.pageCount"
    :current-page.sync="pagerParams.currentPage"
    :total="pagerParams.total">
  </pages>
</div>
</template>

<script>
import VideoCreation from "@/components/activity/VideoCreation";
import pages from "@/components/pages.vue";

export default {
  metaInfo () {
      return {
        title: this.$t('global.全部作品') + " | MANA"
      }
  },
  components: {
    VideoCreation,
    pages
  },

  data() {
    return {
      typeContent: [this.$t('global.全 部'), this.$t('global.最新发布'), this.$t('global.浏览最多'), this.$t('global.点赞最多')],
      typeIndex: 0,
      videoList: [],
      pagerParams: {
        pageSize: 12,
        pageCount: 5,
        currentPage: 1,
        total: 1
      },
      orderBy: {
        type: Number,
        default: undefined
      }
    };
  },

  watch: {
    "pagerParams.currentPage": function() {
      this.getData(this.$route.params.id, {
        orderBy: this.orderBy,
        pageIndex: this.pagerParams.currentPage
      });
    },
    $route: function() {
      let currentID = this.$route.params.id;
      if (currentID == this.detailData.id) return;
      this.getData(this.$route.params.id, { orderBy: this.orderBy });
    },
    orderBy: function() {
      this.getData(this.$route.params.id, { orderBy: this.orderBy });
    }
  },

  methods: {
    selectType(index) {
      this.typeIndex = index
      this.orderBy = index
      if(index === 0) this.orderBy = undefined
    },

    getData(
      activityId,
      { orderBy = undefined, pageIndex = 1, pageSize = 12 } = {}
    ) {
      this.$http
        .get("/api/activity/videoList", {
          params: {
            activityId,
            orderBy,
            pageIndex,
            pageSize
          }
        })
        .then(data => {
          let d = data.data;
          this.videoList = d.list;
          this.pagerParams.currentPage = d.pageIndex;
          this.pagerParams.total = d.totalPage;
          this.pagerParams.pageSize = d.pageSize;
        });
    }
  },

  created() {
    this.getData(this.$route.params.id);
  }
};
</script>

<style lang="stylus" scoped>
.allproduct {
  display: flex;
  flex-wrap: wrap;
}

.videoCreation {
  width: 3.42rem;
  margin: 0.2rem 0.18rem 0 0;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #d5d5d5;
  border-radius: 0.08rem;

  &:nth-child(3n) {
    margin-right: 0;
  }
}

.left-content {
  width: 10.8rem;
  margin-top: 0.2rem;
  padding: 0.4rem 0.6rem;
  background-color: #ffffff;

  .type {
    display: flex;
    color: #333333;
    font-size: 0.2rem;

    span {
      display: inline-block;
      padding: 0 0.5rem;
    }

    .type-right {
      margin-right: 0.86rem;
    }

    .selected {
      color: #0161ff;
    }
  }
}

.pointer {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/match/AllWorks.vue